<template>
  <div>
    <RecycleScroller
      ref="recycleScroller"
      :items="allInterests"
      :item-height="140"
      :buffer="600"
      class="scroller"
      page-mode
      emit-update
      @update="onRecycleScrollerUpdated"
    >
      <VCard
        slot-scope="{ item, index }"
        color="blue-grey darken-2"
        ripple
        @click.stop="onCardClicked(item.listContactsRoute)"
      >
        <VContainer
          fluid
          grid-list-lg
        >
          <VLayout
            fill-height
            align-center
            justify-center
            row
            wrap
          >
            <VFlex xs12>
              <VCard
                color="blue-grey darken-2"
                class="white--text"
              >
                <VLayout
                  row
                  wrap
                  justify-space-between
                >
                  <VFlex
                    xs10
                  >
                    <VCardTitle primary-title>
                      <VLayout
                        row
                        wrap
                      >
                        <VFlex xs12>
                          <div class="headline">
                            {{ item.name }}
                          </div>
                        </VFlex>
                        <VFlex xs12>
                          <div>Profiles: ({{ item.profiles.length }})</div>
                        </VFlex>
                      </VLayout>
                    </VCardTitle>
                  </VFlex>
                  <VFlex
                    xs2
                  >
                    <VLayout
                      column
                      align-end
                      justify-space-between
                      fill-height
                    >
                      <VBtn
                        v-if="followup"
                        small
                        icon
                        dark
                        @click.stop="onFollowupClicked(index)"
                      >
                        <VIcon>mdi-calendar-star</VIcon>
                      </VBtn>
                    </VLayout>
                  </VFlex>
                </VLayout>
              </VCard>
            </VFlex>
          </VLayout>
        </VContainer>
      </VCard>
    </RecycleScroller>
    <InterestFollowupRuleDialog
      v-if="dialog"
      :name="dialogName"
      :interest-id="dialogInterestId"
      :dialog.sync="dialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InterestFollowupRuleDialog from '@/components/automation/InterestFollowupRuleDialog'
export default {
  name: 'InterestTable',
  components: { InterestFollowupRuleDialog },
  props: {
    followup: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      dialog: false,
      dialogName: '',
      dialogInterestId: 0
    }
  },
  computed: {
    ...mapGetters({
      allInterests: 'interest/getAllInterests',
      interestTotalCount: 'interest/getTotalCount'
    })
  },
  methods: {
    tempRemove (event) {
      this.items.splice(event.index, 1)
    },
    onRecycleScrollerUpdated (startIndex, endIndex) {
      if (this.allInterests.length !== 0 && endIndex === this.allInterests.length && endIndex !== this.interestTotalCount) {
        this.$emit('fetchingMore')
      }
    },
    onCardClicked (route) {
      this.$router.push(route)
    },
    onFollowupClicked (index) {
      if (index < 0 || index >= this.allInterests.length) {
        return
      }
      const interest = this.allInterests[index]
      if (interest) {
        this.dialogName = `${interest.name}`
        this.dialogInterestId = Number(interest.id)
        this.dialog = true
      }
    }
  }
}
</script>

<style scoped>
  .fluid {
    padding: 10px;
  }
</style>
